import { Box, Flex, Input, Spacer, useDisclosure, Text } from "@chakra-ui/react"
import { Space, Table } from "antd"
import React, { useEffect, useMemo, useState } from "react"
import "react-datepicker/dist/react-datepicker.css"
import { RiDeleteBin6Line } from "react-icons/ri"
import { useDispatch } from "react-redux"
import { useUsersMaster } from "../../store/users/reducer"
import { IUser } from "../../types/user"
import UserDeleteConfirmation from "../modals/UserDeleteConfirmation"
import styles from "./UserTable.module.scss"
import axios from "axios"

interface props {
  query: any
}

const UserTable: React.FC<props> = ({ query }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [targetuser, setTargetUser] = useState<IUser>()
  const [searchQuery, setSearch] = useState("")
  const dispatch = useDispatch()
  const { masterUsers, busy } = useUsersMaster()
  const [userType, setUsertype] = useState("Verified User")
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false)
  const [userdata, setUserData] = useState<any[]>([])

  console.log(masterUsers, "00000000000000000")

  const searchColumns = useMemo(
    () => ["firstName", "lastName", "middleName", "email"],
    []
  )

  const formatRelativeData = (relatives: any[] | null | undefined) => {
    if (!Array.isArray(relatives) || relatives.length === 0) return "-"

    return relatives
      .filter((rel) => rel && rel.name && rel.birthday)
      .map((rel) => `${rel.name}:- ${rel.birthday}`)
      .join(", ")
  }

  const filteredData = useMemo(() => {
    if (!Array.isArray(masterUsers)) {
      console.log("masterUsers is not an array:", masterUsers)
      return []
    }

    const transformed =
      userType === "Deleted User"
        ? masterUsers
            .filter((u) => /^delete_[a-z]+@ht\.com$/.test(u.email))
            .map((value: any) => {
              return {
                key: value._id,
                name: `${value.firstName || ""} ${value.middleName || ""} ${
                  value.lastName || ""
                }`.trim(),
                firstName: value.firstName || "-",
                lastName: value.lastName || "-",
                email: value.email || "-",
                phoneNumber: value.phoneNumber || "-",
                birthday: value.birthday || "-",
                preferedDays: Array.isArray(value.preferedDays)
                  ? value.preferedDays.join(", ")
                  : "-",
                relativeBirthdays: formatRelativeData(value.relativeBirthdays),
                relativeAnniversary: formatRelativeData(
                  value.relativeAnniversary
                ),
                originalData: value,
              }
            })
        : userType === "Verified User"
        ? masterUsers
            .filter(
              (u) => !u.isGuestLogin && !/^delete_[a-z]+@ht\.com$/.test(u.email)
            )
            .map((value: any) => {
              return {
                key: value._id,
                name: `${value.firstName || ""} ${value.middleName || ""} ${
                  value.lastName || ""
                }`.trim(),
                firstName: value.firstName || "-",
                lastName: value.lastName || "-",
                email: value.email || "-",
                phoneNumber: value.phoneNumber || "-",
                birthday: value.birthday || "-",
                preferedDays: Array.isArray(value.preferedDays)
                  ? value.preferedDays.join(", ")
                  : "-",
                relativeBirthdays: formatRelativeData(value.relativeBirthdays),
                relativeAnniversary: formatRelativeData(
                  value.relativeAnniversary
                ),
                originalData: value,
              }
            })
        : masterUsers
            .filter(
              (u) => u.isGuestLogin && !/^delete_[a-z]+@ht\.com$/.test(u.email)
            )
            .map((value: any) => {
              return {
                key: value._id,
                name: `${value.firstName || ""} ${value.middleName || ""} ${
                  value.lastName || ""
                }`.trim(),
                firstName: value.firstName || "-",
                lastName: value.lastName || "-",
                email: value.email || "-",
                phoneNumber: value.phoneNumber || "-",
                birthday: value.birthday || "-",
                preferedDays: Array.isArray(value.preferedDays)
                  ? value.preferedDays.join(", ")
                  : "-",
                relativeBirthdays: formatRelativeData(value.relativeBirthdays),
                relativeAnniversary: formatRelativeData(
                  value.relativeAnniversary
                ),
                originalData: value,
              }
            })

    return transformed.filter((user: any) =>
      searchColumns.some((column) =>
        String(user[column] || "")
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      )
    )
  }, [masterUsers, searchQuery, searchColumns, userType])

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure()

  const deletes = (value: any) => {
    setTargetUser(value)
    onDeleteOpen()
  }

  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 60,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Login Icon",
      dataIndex: "Image",
      width: 100,
      render: (_: any, record: any) => {
        const imageSrc = (() => {
          if (record.originalData.isEmailLogin) return "/icons/email.svg"
          if (record.originalData.isPhoneLogin) return "/icons/phone.svg"
          if (record.originalData.isGoogleLogin) return "/icons/google.svg"
          if (record.originalData.isAppleLogin) return "/icons/apple.svg"
          if (record.originalData.isGuestLogin) return "/icons/guest.svg"
          // return "/icons/default.svg";
          return "/icons/usermanagement.svg"
        })()

        return (
          <img
            src={imageSrc}
            alt="Login Type"
            style={{
              width: "20px",
              height: "20px",
              // objectFit: "contain",
              // borderRadius: "50%",
            }}
          />
        )
      },
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      width: 120,
    },
    {
      title: "Last name",
      dataIndex: "lastName",
      width: 120,
    },
    {
      title: "Email",
      dataIndex: "email",
      width: 200,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      width: 150,
    },
    {
      title: "Birthday",
      dataIndex: "birthday",
      width: 100,
    },
    {
      title: "Preferred dining days",
      dataIndex: "preferedDays",
      width: 150,
    },
    {
      title: "Family (Relation & Birthday)",
      dataIndex: "relativeBirthdays",
      width: 200,
    },
    {
      title: "Anniversaries (Relation & Date)",
      dataIndex: "relativeAnniversary",
      width: 200,
    },
    {
      title: "Action",
      key: "action",
      width: 100,
      render: (value: any) => (
        <Space size="middle">
          <RiDeleteBin6Line
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
            onClick={() => deletes(value)}
          />
        </Space>
      ),
    },
  ]

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }

  const formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, "0")
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const year = date.getFullYear()

    return `${day}-${month}-${year}`
  }

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Flex w="full" alignItems="center" justifyContent="space-between">
            <Box
              w="100%"
              display="flex"
              alignItems="center"
              gap="10px"
              justifyContent="space-between"
            >
              <Box
                display="flex"
                alignItems="center"
                bg="#FFF"
                border="1px solid #b2b2b233"
                borderRadius="12px"
                w="498px"
                padding="8px"
              >
                <Box
                  pl={2}
                  display="flex"
                  alignItems="center"
                  color="#9E9E9E"
                  fontSize="2xl"
                >
                  <img
                    src="/icons/searchlogo.svg"
                    alt="searchlogo"
                    style={{ height: "24px", width: "24px" }}
                  />
                </Box>

                <Input
                  id="search"
                  type="text"
                  placeholder="Search or type a command"
                  onChange={(e) => setSearch(e.target.value)}
                  fontSize="sm"
                  border="none"
                  outline="none"
                  color="#757575"
                  _focus={{
                    border: "none",
                    outline: "none",
                    boxShadow: "none",
                  }}
                  bg={"transparent"}
                  style={{
                    outline: "none",
                    boxShadow: "none",
                  }}
                />
              </Box>

              <div style={{ position: "relative" }}>
                <Box
                  borderRadius="12px"
                  backgroundColor="#fff"
                  padding="8px 12px;"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  gap="10px"
                  cursor="pointer"
                  w="fit-content"
                  onClick={() => {
                    setIsStatusDropdownOpen(!isStatusDropdownOpen)
                  }}
                >
                  <Text fontSize="sm" color="#424242" margin={0}>
                    {userType || "user type"}
                  </Text>

                  <img
                    src="/icons/dropdownarrow.svg"
                    alt="dropdownarrow"
                    style={{ height: "24px", width: "24px" }}
                  />
                </Box>
                {isStatusDropdownOpen && (
                  <div className={styles.dropdownPopup}>
                    <div className={styles.categoriesList}>
                      {["Verified User", "Guest User", "Deleted User"].map(
                        (status) => (
                          <div
                            key={status}
                            onClick={() => {
                              setUsertype(status)
                              setIsStatusDropdownOpen(false)
                            }}
                          >
                            <Text
                              className={`${styles.category} ${
                                userType === status
                                  ? styles.selectedCategory
                                  : ""
                              }`}
                              color="#424242"
                              fontSize="14px"
                            >
                              {status}
                            </Text>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>
            </Box>

            <Spacer />

            {/* <Box position="relative">
              <Box
                borderRadius="12px"
                backgroundColor="#fff"
                padding="8px 12px"
                display="flex"
                gap="10px"
                alignItems="center"
                cursor="pointer"
                onClick={() => setIsDatePickerOpen(!isDatePickerOpen)}
              >
                <Text color="#424242" fontSize="14px">
                  {formatDate(startDate)}
                </Text>
                <img
                  src="/icons/calenderlogo.svg"
                  alt="dropdownarrow"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              {isDatePickerOpen && (
                <Box className={styles.datepickerDiv}>
                  <DatePicker
                    selected={new Date(startDate)}
                    onChange={(date: Date) => {
                      setStartDate(date);
                      setIsDatePickerOpen(false);
                    }}
                    maxDate={new Date()}
                    inline
                  />
                </Box>
              )}
            </Box> */}
          </Flex>
          {/* {loading ? (
            <Spin size="large" />
          ) : ( */}
          <Table
            rowSelection={rowSelection}
            rowKey="key"
            columns={columns}
            dataSource={filteredData}
            scroll={{ x: "max-content" }}
            size="middle"
            pagination={{
              position: ["bottomRight"],
              pageSize: 9,
            }}
            style={{
              backgroundColor: "white",
              borderRadius: 6,
            }}
            rowClassName={(record: any) => record.color}
            loading={busy && filteredData.length === 0 ? true : false}
          />
          {/* )} */}
        </div>
      </div>
      {isDeleteOpen && targetuser && (
        <UserDeleteConfirmation
          isOpen
          onClose={onDeleteClose}
          event={targetuser}
        />
      )}
    </>
  )
}

export default UserTable
